/**
 * Collection Discovery [New]
 * Mirrors Framer whileInView from CollectionDiscovery.section.jsx
 *
 * Heading / aside:
 *   initial {{ opacity: 0, y: 24 }}
 *   whileInView {{ opacity: 1, y: 0 }}
 *   viewport {{ once: true, margin: "-100px" }}
 *   transition {{ duration: 1.1, ease: [0.22, 1, 0.36, 1], delay: 0 | 0.1 }}
 *
 * Cards:
 *   initial {{ opacity: 0, y: 140 }}
 *   whileInView {{ opacity: 1, y: 0 }}
 *   viewport {{ once: true, margin: "-80px" }}
 *   transition {{ duration: 1.5, ease: EASE, delay: i * 0.18 }}
 */
(function () {
  'use strict';

  var SECTION_TYPE = 'collection-discovery-new';
  var instances = new WeakMap();

  function CollectionDiscovery(root) {
    this.root = root;
    this.observers = [];
    this.reducedMotion =
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (this.reducedMotion) {
      root.querySelectorAll('[data-reveal]').forEach(function (el) {
        el.classList.add('is-inview');
      });
      return;
    }

    this.observeGroup(
      root.querySelectorAll('[data-reveal="heading"], [data-reveal="aside"]'),
      '-100px'
    );
    this.observeGroup(root.querySelectorAll('[data-reveal="card"]'), '-80px');
  }

  CollectionDiscovery.prototype.observeGroup = function (nodes, rootMarginY) {
    var self = this;
    if (!nodes || !nodes.length || typeof IntersectionObserver === 'undefined') {
      Array.prototype.forEach.call(nodes || [], function (el) {
        el.classList.add('is-inview');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        /* Framer viewport.margin: "-100px" / "-80px" → CSS rootMargin shorthand */
        rootMargin: rootMarginY + ' 0px ' + rootMarginY + ' 0px',
        threshold: 0,
      }
    );

    Array.prototype.forEach.call(nodes, function (el) {
      /* Apply per-element delay from data-reveal-delay (ms) for cards beyond CSS presets */
      var delay = el.getAttribute('data-reveal-delay');
      if (delay && !el.style.transitionDelay) {
        el.style.transitionDelay = delay + 'ms';
      }
      observer.observe(el);
    });

    this.observers.push(observer);
  };

  CollectionDiscovery.prototype.destroy = function () {
    this.observers.forEach(function (observer) {
      observer.disconnect();
    });
    this.observers = [];
  };

  function initRoot(root) {
    if (!root || instances.has(root)) return;
    instances.set(root, new CollectionDiscovery(root));
  }

  function destroyRoot(root) {
    if (!root || !instances.has(root)) return;
    instances.get(root).destroy();
    instances.delete(root);
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]')
      .forEach(initRoot);
  }

  function findRoot(sectionEl) {
    if (!sectionEl) return null;
    if (sectionEl.matches && sectionEl.matches('[data-section-type="' + SECTION_TYPE + '"]')) {
      return sectionEl;
    }
    return sectionEl.querySelector
      ? sectionEl.querySelector('[data-section-type="' + SECTION_TYPE + '"]')
      : null;
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  if (document.readyState !== 'loading') {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = findRoot(event.target);
    if (!root) return;
    destroyRoot(root);
    initRoot(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = findRoot(event.target);
    if (root) destroyRoot(root);
  });
})();
